import React, { useCallback } from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Chip from '@material-ui/core/Chip';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';

/**
 *
 * @param label
 * @param fullWidth
 * @param value
 * @param setValue
 * @param options
 * @param multiple
 * @param resolveIds resolve ids to names
 * @returns {JSX.Element}
 * @constructor
 */
const PriceRuleSelect = ({
    label = '',
    fullWidth,
    value,
    setValue,
    options,
    multiple = false,
    resolveIds = false
}) => {
    const sortedOptions = options.sort((a, b) => {
        if (a.name < b.name) {
            return -1;
        }
        if (a.name > b.name) {
            return 1;
        }

        return 0;
    });

    const onChange = useCallback(
        event => {
            setValue(event.target.value);
        },
        [setValue]
    );

    const renderValue = useCallback(
        newValue =>
            multiple ? (
                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                    {newValue.map(v => (
                        <Chip
                            key={v}
                            label={
                                options.find(opt => opt.id === v) &&
                                options.find(opt => opt.id === v).name
                            }
                            style={{ margin: '0.1rem' }}
                        />
                    ))}
                </div>
            ) : resolveIds ? (
                options.find(opt => opt.id === newValue) ? (
                    options.find(opt => opt.id === newValue).name
                ) : (
                    `#${newValue}`
                )
            ) : (
                newValue
            ),
        [multiple, options, resolveIds]
    );
    return (
        <FormControl fullWidth={fullWidth}>
            {label && <InputLabel>{label}</InputLabel>}
            <Select
                label={label}
                value={value}
                onChange={onChange}
                multiple={multiple}
                renderValue={renderValue}
            >
                {sortedOptions.map(option => (
                    <MenuItem key={option.id} value={option.id}>
                        {option.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default PriceRuleSelect;
